import React, { useMemo } from 'react';
import cn from 'clsx';
import { memo } from 'common/hocs/memo';
import {
  adaptiveSizeStylesMap,
  adaptiveVariantStylesMap,
  StyledTypography,
  sizeStylesMap,
  variantStylesMap,
  extraSize,
} from './typography-styles';
import { AdaptiveText, AdaptiveTextSize, Header, Size, Text, TypographyProps, UnsizableText } from './typography-types';

export const Typography = memo(
  ({ adaptive = true, children, size, className, variant, ...rest }: TypographyProps) => {
    const classNames = useMemo(
      () =>
        cn(
          className,
          sizeStylesMap[variant as Text]?.[size as Size],
          variantStylesMap[variant as Header & Text & UnsizableText],
          {
            [extraSize]: size === 'extra',
            [adaptiveVariantStylesMap[variant as AdaptiveText]]: adaptive,
            [adaptiveSizeStylesMap[variant as AdaptiveTextSize]?.[size as Size]]: adaptive,
          }
        ),
      [adaptive, className, size, variant]
    );


    return (
      <StyledTypography className={classNames} size={size} variant={variant} {...rest}>
        {children}
      </StyledTypography>
    );
  }
);
